import React, { useState } from 'react';
import { IModalWindow, ModalWindow } from '../modal/ModalWindow';
import { SectionWrapper } from '../SectionWrapper';
import './ProfileSettingsAccountSecurity.scss';
import { AccountSecurityChangePassword } from './AccountSecurityChangePassword';
import { AccountSecurityAddKey } from './AccountSecurityAddKey';

export const ProfileSettingsAccountSecurity = (): JSX.Element => {
	const [modalState, setModalState] = useState<IModalWindow>({
		isOpen: false
	});
	const closeModal = (): void => setModalState(prev => ({ ...prev, isOpen: false }));
	// const openAuthenticationKeyModal = (): void => {
	// 	setModalState({
	// 		isOpen: true,
	// 		modalTitle: 'Chose your second step verification',
	// 		content: (
	// 			<div>
	// 				<ButtonComponent
	// 					buttonName="Add SMS"
	// 					additionalClass="d-block w-100 mb-10"
	// 					onButtonClick={openModalWithMobPhone}
	// 				/>
	// 				<ButtonComponent buttonName="Use an authentication app"/>
	// 			</div>
	// 		)
	// 	});
	// };
	// const openModalWithMobPhone = (): void => {
	// 	closeModal();
	// 	setModalState({
	// 		isOpen: true,
	// 		modalTitle: 'Please enter your phone number',
	// 		content: (
	// 			<AddPhoneForm
	// 				closeModal={closeModal}
	// 				setIsVerifyModalOpen={setIsVerifyModalOpen}
	// 				// setPhoneNumber={setPhoneNumber}
	// 			/>
	// 		),
	// 		contentClassName: 'd-block',
	// 		minHeight: '0'
	// 	});
	// };

	return (
		<>
			<SectionWrapper title="Account security" isCardBody sectionAdditionalClass="mb-5">
				<div className="d-md-flex">
					<AccountSecurityChangePassword/>
					<AccountSecurityAddKey />
				</div>
			</SectionWrapper>
			<ModalWindow
				{...modalState}
				onClose={closeModal}
			/>

		</>
	);
};
